function Whatsapp({
  className,
  color,
}: {
  className?: string;
  color?: string;
}): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path
        d="M0.916016 23.1535L2.47415 17.4613C1.51267 15.7951 1.00745 13.9063 1.00838 11.9695C1.01115 5.91428 5.93861 0.986816 11.9929 0.986816C14.9309 0.98774 17.6888 2.13209 19.7632 4.20837C21.8367 6.28465 22.9783 9.0444 22.9774 11.9796C22.9746 18.0358 18.0472 22.9632 11.9929 22.9632C10.1549 22.9623 8.3437 22.5014 6.73938 21.6258L0.916016 23.1535ZM7.00908 19.6373C8.55705 20.5563 10.0348 21.1068 11.9892 21.1077C17.021 21.1077 21.12 17.0124 21.1228 11.9778C21.1246 6.93302 17.045 2.84327 11.9966 2.84143C6.96105 2.84143 2.86484 6.93672 2.86299 11.9704C2.86206 14.0254 3.46426 15.5642 4.47561 17.174L3.55293 20.5434L7.00908 19.6373ZM17.5262 14.5907C17.4579 14.4762 17.275 14.4078 16.9998 14.2702C16.7255 14.1326 15.3761 13.4685 15.1239 13.3771C14.8727 13.2856 14.6898 13.2394 14.506 13.5147C14.3232 13.789 13.7967 14.4078 13.6369 14.5907C13.4771 14.7736 13.3164 14.7967 13.0421 14.659C12.7678 14.5214 11.883 14.2323 10.8347 13.2967C10.0191 12.5689 9.46773 11.6702 9.30795 11.395C9.14816 11.1207 9.29132 10.972 9.42802 10.8353C9.55178 10.7124 9.70233 10.5148 9.83995 10.3541C9.97941 10.1952 10.0247 10.0807 10.117 9.89689C10.2085 9.71402 10.1632 9.55331 10.0939 9.41569C10.0247 9.279 9.47604 7.92775 9.24791 7.37821C9.0244 6.84343 8.79811 6.91548 8.63002 6.90716L8.10356 6.89793C7.92068 6.89793 7.62328 6.96627 7.37206 7.24151C7.12084 7.51675 6.4115 8.1799 6.4115 9.53114C6.4115 10.8824 7.39515 12.1874 7.53184 12.3703C7.66946 12.5532 9.46681 15.3259 12.2201 16.5146C12.8749 16.7972 13.3866 16.9662 13.7847 17.0927C14.4423 17.3015 15.0408 17.2719 15.5137 17.2017C16.0411 17.1232 17.1374 16.5377 17.3665 15.8967C17.5955 15.2548 17.5955 14.7052 17.5262 14.5907Z"
        fill={color}
      />
    </svg>
  );
}

export default Whatsapp;
